module.exports = __webpack_public_path__ + "static/media/S1N12-2.84d5b5d7.svg";